// Generated by CoffeeScript 1.10.0
(function() {
  var Eidolon, dereference, generateExample, generateSchema, inherit;

  dereference = require('./dereference');

  generateExample = require('./example');

  generateSchema = require('./schema');

  inherit = require('./inherit').inherit;

  Eidolon = (function() {
    function Eidolon(structures) {
      this.structures = structures != null ? structures : {};
    }

    Eidolon.prototype.dereference = function(element) {
      return dereference(element, this.structures);
    };

    Eidolon.prototype.example = function(element) {
      return generateExample(element, this.structures);
    };

    Eidolon.prototype.schema = function(element) {
      return generateSchema(element, this.structures);
    };

    return Eidolon;

  })();

  module.exports = {
    Eidolon: Eidolon,
    dereference: dereference,
    example: generateExample,
    inherit: inherit,
    schema: generateSchema
  };

}).call(this);



/*****************
 ** WEBPACK FOOTER
 ** ./~/eidolon/lib/eidolon.js
 ** module id = 161
 ** module chunks = 0
 **/